/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Interweave } from "interweave";
import ExerciseEducationalVideoModal from "../ExerciseEducationalVideoModal";
import { Button } from "react-bootstrap";
import { updateUserProgramDayExercise } from "../../../actions/user_program";
import { connect, useDispatch } from "react-redux";
import { getSkipReasons } from "../../../actions/user_test";
import SkipExerciseModal from "../AssessmentTimer/SkipExerciseModal";
import StatusCheckoutModal from "../StatusCheckoutModal";
import Modal from "react-bootstrap/Modal";
import { CommonPageData } from "../../../styles/common.style";
import ExerciseTitle from "./ExerciseTitle";
import TimerIcon from "./Icons/TimerIcon";
import EndExerciseModal from "./EndExerciseModal";
import ExerciseHistory from "./ExerciseHistory";
import ExerciseVideoPlayer from "./ExerciseVideoPlayer";
import { flipExerciseOrientation } from "../../../actions/user_active_exercise";
import EndExerciseConfirmModal from "./EndExerciseConfirmModal";
import { incrementCircuitCount } from "../../../actions/user_active_day";
import ExerciseHelperSection from "./ExerciseHelperSection";
import ExerciseInfoModal from "./ExerciseInfoModal";

const ExerciseContainer = ({
  activeExercise: currentExercise,
  activeDay,
  program,
  nextExerciseId,
  setActiveExercise,
  updateUserProgramDayExercise,
  exerciseUpdateSuccess,
  getSkipReasons,
  skipTestReason,
  skipExerciseSuccess,
  setRepeatCircuit,
  filteredExercises,
  flipExerciseOrientation,
  incrementCircuitCount,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [activeExerciseLevel, setActiveExerciseLevel] = useState(null); // TODO: Remove this state if not used
  const [showEducationalModal, setShowEducationalModal] = useState(false);
  const [isCompleteDisable, setIsCompleteDisable] = useState(false); // TODO: Remove this state if not used
  const [isStart, setIsStart] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false); // TODO: Remove this state if not used
  const [showExerciseSkipModal, setShowExerciseSkipModal] = useState(false);
  const [showStatusOutModal, setShowStatusOutModal] = useState(false);

  const [dumbbellsValue, setDumbbellsValue] = useState(0);
  const [timeValue, setTimeValue] = useState("");
  const [noteValue, setNoteValue] = useState("");
  const [repsValue, setRepsValue] = useState(null);
  const [durationValue, setDurationValue] = useState("");
  const [exerciseStartTime, setExerciseStartTime] = useState("");
  const [exerciseEndTime, setExerciseEndTime] = useState("");

  const [seconds, setSeconds] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [error, setError] = useState("");

  const [errorDumbell, setErrorDumbell] = useState("");
  const [errorNote, setErrorNote] = useState("");

  const [showWeight, setShowWeight] = useState(false);
  const dispatch = useDispatch();

  const [isEndExerciseConfirmModalOpen, setIsEndExerciseConfirmModalOpen] =
    useState(false);
  const [isEndExercise, setIsEndExercise] = useState(false);

  const handleShow = () => setShowEducationalModal(true);
  const handleClose = () => setShowEducationalModal(false);
  const handleCloseExerciseSkipModal = () => setShowExerciseSkipModal(false);
  const handleStatusOutModal = () => setShowStatusOutModal(false);
  const handleCloseWeight = () => setShowWeight(false);
  const handleEndExerciseConfirmModalClose = () =>
    setIsEndExerciseConfirmModalOpen(false);
  const handleEndExercise = () => setIsEndExercise(false);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const [counter, setCounter] = useState(3);
  const [isCountTimerActive, setIsCountTimerActive] = useState(false);
  const [showCounter, setIsShowCounter] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [selectedIntensity, setSelectedIntensity] = useState("");

  const [newWeigtValue, setNewWeightValue] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // TODO: Remove this state if not used
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const handleCloseExercise = () => setIsInfoModalOpen(false);
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(formatTime(seconds));
  const [isTimeChanged, setIsTimeChanged] = useState(false);
  const [hasChangedKg, setHasChangedKg] = useState(false);
  const [hasChangedReps, setHasChangedReps] = useState(false);
  const [hasChangedTime, setHasChangedTime] = useState(false);
  const [exerciseAttempts, setExerciseAttempts] = useState([]);

  const navigate = useNavigate();

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "150px",
      height: "100px",
      backgroundColor: "#f0f0f0",
      borderRadius: "10px",
      padding: "10px",
    },
    input: {
      width: "60%",
      border: "none",
      borderBottom: "2px solid #000",
      textAlign: "center",
      fontSize: "28px",
      background: "transparent",
      outline: "none",
      height: "30px",
      color: "#D3D3D3",
      fontWeight: "600",
    },
    label: {
      marginTop: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#666",
    },
    button: {
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      textTransform: "uppercase",
    },
    buttonStart: {
      color: "#000",
      border: "1px solid red",
      borderRadius: "10px",
      cursor: "pointer",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      textTransform: "uppercase",
      background: "#fff",
      fontWeight: "500",
    },
    buttonComplete: {
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      background: "#000",
      textTransform: "uppercase",
    },
    buttonNext: {
      color: "white",
      border: "none",
      borderRadius: "10px",
      padding: "25px 20px",
      fontSize: "20px",
      cursor: "pointer",
      fontWeight: "bold",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "background-color 0.3s ease",
      height: "100px",
      width: "120px",
      background: "#fb1417",
      textTransform: "uppercase",
    },
    buttonHover: {
      backgroundColor: "#45a049",
    },
    equipments: {
      fontWeight: "bold",
      fontSize: "16px",
    },
    notfound: {
      color: "red",
    },
    editIcon: {
      position: "absolute",
      right: "-30px", // Adjust distance from input
      cursor: "pointer",
      fontSize: "20px",
      color: "#333",
    },
  };

  const precisionLift = [
    {
      id: 1,
      difficulty: "Very Easy",
      weight_change: 7.5,
    },
    {
      id: 2,
      difficulty: "Easy",
      weight_change: 5,
    },
    {
      id: 3,
      difficulty: "Slightly Easy",
      weight_change: 2.5,
    },
    {
      id: 4,
      difficulty: "Somewhat Easy",
      weight_change: 1,
    },
    {
      id: 5,
      difficulty: "Moderate",
      weight_change: 0,
    },
    {
      id: 6,
      difficulty: "Somewhat Hard",
      weight_change: -1,
    },
    {
      id: 7,
      difficulty: "Slightly Hard",
      weight_change: -2.5,
    },
    {
      id: 8,
      difficulty: "Hard",
      weight_change: -5,
    },
    {
      id: 9,
      difficulty: "Very Hard",
      weight_change: -7.5,
    },
  ];

  const heavyLift = [
    {
      id: 1,
      difficulty: "Very Easy",
      weight_change: 20,
    },
    {
      id: 2,
      difficulty: "Easy",
      weight_change: 15,
    },
    {
      id: 3,
      difficulty: "Slightly Easy",
      weight_change: 10,
    },
    {
      id: 4,
      difficulty: "Somewhat Easy",
      weight_change: 5,
    },
    {
      id: 5,
      difficulty: "Moderate",
      weight_change: 0,
    },
    {
      id: 6,
      difficulty: "Somewhat Hard",
      weight_change: -5,
    },
    {
      id: 7,
      difficulty: "Slightly Hard",
      weight_change: -10,
    },
    {
      id: 8,
      difficulty: "Hard",
      weight_change: -15,
    },
    {
      id: 9,
      difficulty: "Very Hard",
      weight_change: -20,
    },
  ];

  useEffect(() => {
    // Update viewport width when the window is resized
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };
    // Attach the resize event listener
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Reset note value when the active exercise changes
  useEffect(() => {
    setNoteValue("");

    setExerciseAttempts(
      currentExercise?.userProgramDayExercisesAttempt?.filter((attempt) => {
        if (currentExercise.position === 3) {
          if (currentExercise.is_flip_orientation) {
            return attempt.exercise_orientation === "right";
          } else {
            return attempt.exercise_orientation === "left";
          }
        }

        return true;
      })
    );
  }, [currentExercise]);

  useEffect(() => {
    if (currentExercise) {
      setIsPaused(true);
      setIsTimerActive(false);
      setPlaying(false);

      setDumbbellsValue(
        currentExercise.user_weight !== 0
          ? currentExercise.user_weight
          : currentExercise.exerciseLevel.suggested_weight_lbs
      );

      setRepsValue(
        currentExercise.exerciseLevel.metric === 10
          ? currentExercise.exerciseLevel.reps
          : ""
      );

      setIsStart(true);
      setErrorDumbell("");
      setErrorNote("");
      setError("");
    }
  }, [currentExercise]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({
      top: 0, // 100 pixels from the top
      behavior: "smooth", // Smooth scroll behavior
    });
  }, []);

  useEffect(() => {
    let interval = null;
    if (isTimerActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
        setDurationValue(seconds + 1);
      }, 1000);
    } else if (!isTimerActive && seconds !== 0) {
      clearInterval(interval);
    }
    setExerciseEndTime(new Date());
    return () => clearInterval(interval);
  }, [isTimerActive, seconds]);

  useEffect(() => {
    let interval = null;
    if (isCountTimerActive) {
      interval = setInterval(() => {
        setCounter(counter - 1);
        if (counter < 2) {
          setIsShowCounter(false);
          setSeconds(0);
          setExerciseStartTime(new Date());
          setIsTimerActive(true);
          setIsStart(true);
          setIsCountTimerActive(false);
          setPlaying(true);
        }
      }, 1000);
    } else if (!isCountTimerActive && counter !== 0) {
      clearInterval(interval);
      setIsCountTimerActive(false);
      setIsShowCounter(false);
    }

    if (counter === 0) {
      setHasChangedTime(true);
    }

    setExerciseEndTime(new Date());
    return () => clearInterval(interval);
  }, [isCountTimerActive, counter]);

  const handleStart = () => {
    setCounter(3);
    setIsCountTimerActive(true);
    setIsShowCounter(true);
    setIsTimeChanged(true);
  };

  const handlePause = () => {
    setIsPaused(true);
    setIsTimerActive(false);
    setPlaying(false);
  };

  const handleResume = () => {
    setIsEditing(false);
    setIsPaused(false);
    setIsTimerActive(true);
    setPlaying(true);
  };

  useEffect(() => {
    if (!skipTestReason) {
      getSkipReasons();
    }
  }, []);

  const handleClick = (event) => {
    // 👇️ toggle isActive state on click
    setIsActive((current) => !current);
  };

  function getNextActiveExerciseId(currentExercise, nextExerciseId) {
    // this is not the cleanest way to do this, but it works for now
    // if the current exercise has two orientations, we need to only flip the orientation
    // no need to change the exercise
    if (
      currentExercise.position === 3 &&
      !currentExercise.is_flip_orientation
    ) {
      return currentExercise.id;
    }

    if (!nextExerciseId) {
      return currentExercise.id;
    }

    return nextExerciseId;
  }

  function shouldFlipOrientation(currentExercise) {
    // exercise is already flipped
    if (currentExercise?.is_flip_orientation) {
      return false;
    }

    // exercise is not flipped and has two orientations
    return currentExercise.position === 3;
  }

  function finishCircuit() {
    incrementCircuitCount();
    setIsEndExerciseConfirmModalOpen(true);
  }

  function moveToNextExercise(exerciseId) {
    if (exerciseId) {
      setActiveExercise(exerciseId);
    }
    if (nextExerciseId == null) {
      finishCircuit();
    }
  }

  function resetExerciseValues() {
    setIsTimerActive(false);
    setIsStart(false);
    setError("");
    setErrorDumbell("");
    setSeconds(0);
    setRepsValue(null);
    setDumbbellsValue(null);
  }

  function getOrientationValue(position, isFlip) {
    if (position === 1) {
      return "left";
    }
    if (position === 2) {
      return "right";
    }
    if (position === 3) {
      if (isFlip) {
        return "right";
      }

      return "left";
    }
    if (position === 4) {
      return "center";
    }
    return "none";
  }

  // Function for the "Done" button click
  const handleSubmit = async () => {
    const nextActiveExerciseId = getNextActiveExerciseId(
      currentExercise,
      nextExerciseId
    );

    let dt = {
      filteredExercises: filteredExercises.length > 0 ? filteredExercises : [],
      user_weight: newWeigtValue,
      intensity_level: selectedIntensity,
      reps: repsValue ? repsValue : 0,
      user_program_day_exercise_id: currentExercise.id,
      user_lbs: dumbbellsValue ? dumbbellsValue : 0,
      user_time: timeValue ? timeValue : "",
      start_at: exerciseStartTime ? exerciseStartTime : "",
      end_at: exerciseEndTime ? exerciseEndTime : "",
      note: noteValue ? noteValue : "",
      duration: durationValue ? durationValue : "",
      active_exercise_id: nextActiveExerciseId,
      is_flip_orientation: shouldFlipOrientation(currentExercise),
      exercise_orientation: getOrientationValue(
        currentExercise.position,
        currentExercise.is_flip_orientation
      ),
      active_day_id: currentExercise.user_program_day_id
        ? currentExercise.user_program_day_id
        : "",
    };

    // TODO: Move this logic to a separate function or action creator
    resetExerciseValues();

    await updateUserProgramDayExercise(dt, currentExercise.id);

    setIsCompleteDisable(false);
    setNewWeightValue(0);
    setSelectedIntensity("");

    setShowWeight(false);
    setCounter(3);
    setIsCountTimerActive(false);
    setIsShowCounter(false);

    if (shouldFlipOrientation(currentExercise)) {
      // If the exercise is already flipped, we just need to move to the next exercise
      flipExerciseOrientation();
    } else {
      moveToNextExercise(nextActiveExerciseId);
    }

    window.scrollTo({
      top: 200,
      behavior: "smooth",
    });
  };

  useEffect(() => {
  }, [dumbbellsValue]);

  useEffect(() => {
    if (!showStatusOutModal) {
      setIsStart(true);
    } else {
      setIsStart(false);
    }
  }, [showStatusOutModal]);

  useEffect(() => {
    if (exerciseUpdateSuccess !== null && exerciseUpdateSuccess !== undefined) {
      dispatch({ type: "USER_PROGRAM_EXERCISE_UPDATE_PURGE" });
      setNoteValue("");
    }
  }, [exerciseUpdateSuccess, dispatch, nextExerciseId]);

  const handleCompleteExercise = () => {
    setIsStart(false);
    setShowExerciseSkipModal(false);
    setShowEducationalModal(false);
    setShowStatusOutModal(true);
    setIsEndExerciseConfirmModalOpen(false);
    setIsEndExercise(true);
  };

  const handleRepeatCircuit = () => {
    setRepeatCircuit();
    setIsEndExerciseConfirmModalOpen(false);
  };

  const setActiveExerciseFunc = (data) => {
    setActiveExercise(data);
  };

  const setDumbbellsValueFunc = (e) => {
    setDumbbellsValue(e.target.value);
    setHasChangedKg(true);
    if (e.target.value.length > 5) {
      setErrorDumbell("Max length is 5");
      return;
    } else {
      setErrorDumbell("");
    }
  };

  const setTimeValueFunc = (e) => {
    setHasChangedTime(true);
    setTimeValue(e.target.value);
  };

  const setNoteValueFunc = (e) => {
    if (e.target.value.length > 500) {
      setErrorNote("Max length is 500");
      return;
    } else if (e.target.value.length === 0) {
      setNoteValue(e.target.value);
      if (repsValue === null) {
        setIsCompleteDisable(false);
      }
    } else {
      setErrorNote("");
      setNoteValue(e.target.value);
      setIsCompleteDisable(true);
    }
  };

  const setRepsValueFunc = (e) => {
    setHasChangedReps(true);
    const parsedRepsValue = parseInt(e.target.value, 10);

    if (isNaN(parsedRepsValue)) {
      setError("Please enter a valid number of reps");
      setRepsValue(null);
      if (noteValue?.length === 0) {
        setIsCompleteDisable(false);
      }
      return;
    } else if (!parsedRepsValue || !Number.isInteger(parsedRepsValue)) {
      setRepsValue(null);
      setError("Please enter a valid number of reps");
      if (noteValue?.length === 0) {
        setIsCompleteDisable(false);
      }
      return;
    } else {
      setError("");
      setRepsValue(e.target.value);
      setIsCompleteDisable(true);
    }
  };

  const handleFinishNew = async () => {
    setIsPaused(true);
    setIsTimerActive(false);
    setPlaying(false);
  };

  const handleFinish = async () => {
    setPlaying(false);
    setIsPaused(false);

    if (error || errorDumbell || errorNote) {
      return;
    }

    let parsedRepsValue = parseInt(repsValue, 10);

    if (
      currentExercise.exerciseLevel.metric === 10 &&
      (!parsedRepsValue ||
        !Number.isInteger(parsedRepsValue) ||
        parsedRepsValue === "")
    ) {
      setError("Please enter a valid number of reps");
      return;
    }
    if (
      currentExercise.exerciseLevel.reps &&
      currentExercise.exerciseLevel.metric === 20 &&
      !timeValue
    ) {
      setError("Please enter the time.");
      return;
    }
    if (
      currentExercise.exerciseLevel.suggested_weight_lbs &&
      (dumbbellsValue == null || dumbbellsValue === "")
    ) {
      setErrorDumbell("Please enter the weight.");
      return;
    }

    if (
      currentExercise.exerciseLevel.metric === 10 &&
      dumbbellsValue &&
      repsValue
    ) {
      setShowWeight(true);
    }

    const nextActiveExerciseId = getNextActiveExerciseId(
      currentExercise,
      nextExerciseId
    );

    let dt = {
      reps: repsValue ? repsValue : 0,
      user_program_day_exercise_id: currentExercise.id,
      user_lbs: dumbbellsValue ? dumbbellsValue : 0,
      user_time: timeValue ? timeValue : "",
      start_at: exerciseStartTime ? exerciseStartTime : "",
      end_at: exerciseEndTime ? exerciseEndTime : "",
      note: noteValue ? noteValue : "",
      duration: durationValue ? durationValue : "",
      active_exercise_id: nextActiveExerciseId,
      is_flip_orientation: shouldFlipOrientation(currentExercise),
      exercise_orientation: getOrientationValue(
        currentExercise.position,
        currentExercise.is_flip_orientation
      ),
      active_day_id: currentExercise.user_program_day_id
        ? currentExercise.user_program_day_id
        : "",
    };

    setError("");
    setErrorDumbell("");
    setSeconds(0);
    setIsCompleteDisable(false);
    setInputValue(formatTime(0));

    if (hasChangedKg) setHasChangedKg(false);
    if (hasChangedReps) setHasChangedReps(false);
    if (hasChangedTime) setHasChangedTime(false);

    // if suggested_weight_lbs is available, then show the weight modal
    // otherwise, just update the exercise attempts
    if (!currentExercise.exerciseLevel.suggested_weight_lbs) {
      updateUserProgramDayExercise(dt, currentExercise.id);
      setDurationValue("");
      setIsTimerActive(false);
      setIsStart(false);

      if (hasChangedKg) setHasChangedKg(false);
      if (hasChangedReps) setHasChangedReps(false);
      if (hasChangedTime) setHasChangedTime(false);

      if (shouldFlipOrientation(currentExercise)) {
        // If the exercise is already flipped, we just need to move to the next exercise
        flipExerciseOrientation();
      } else {
        moveToNextExercise(nextActiveExerciseId);
      }
    }

    window.scrollTo({
      top: 200, // 100 pixels from the top
      behavior: "smooth", // Smooth scroll behavior
    });
  };

  // TODO: Instead of this complex logic, we need to refactor the code to make it more understandable
  useEffect(() => {
    if (skipExerciseSuccess) {
      resetExerciseValues();

      dispatch({ type: "USER_SKIP_EXERCISE_PURGE" });
      if (nextExerciseId) {
        setActiveExerciseFunc(nextExerciseId);
      } else {
        finishCircuit();
      }
    }
  }, [skipExerciseSuccess]);

  const clearRepsValue = () => {
    setRepsValue(0);
  };

  const clearDumbellsValue = () => {
    setDumbbellsValue(0);
  };

  // Function to handle selection
  const handleSelectIntensity = (event, weight) => {
    let main_weight = parseFloat(dumbbellsValue);

    let new_weight = main_weight + weight;

    setNewWeightValue(new_weight);
    setSelectedIntensity(event);
  };

  const handleEdit = () => {
    setIsEditing((prev) => !prev);
    setInputValue(formatTime(seconds));
    handlePause();
    setIsTimeChanged(false);
  };

  function parseTime(input) {
    const parts = input.split(":");
    if (parts.length === 2) {
      const min = parseInt(parts[0] || "0", 10); // handles empty string before ':'
      const sec = parseInt(parts[1] || "0", 10);
      return min * 60 + sec;
    } else if (parts.length === 1 && input) {
      // e.g., just "30"
      return parseInt(input, 10);
    }
    return 0;
  }

  function formatTime(seconds) {
    return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(
      seconds % 60
    ).padStart(2, "0")}`;
  }

  const handleChange = (e) => {
    setHasChangedTime(true);
    setInputValue(e.target.value);
    setIsPaused(false);
    setIsTimeChanged(true);
    const newSeconds = parseTime(e.target.value);
    setSeconds(newSeconds);
  };

  return (
    <>
      <CommonPageData>
        <section className="test1_001">
          <div className="container">
            {currentExercise ? (
              <div className="row justify-content-center">
                <div className="col-12 col-xl-6 col-lg-12 col-md-12">
                  <ExerciseTitle
                    exerciseName={currentExercise.exerciseLevel.file_name}
                    instruction={currentExercise.exerciseLevel.instructions}
                  />

                  <ExerciseVideoPlayer
                    showExercise={currentExercise}
                    playing={playing}
                    counter={counter}
                    showCounter={showCounter}
                  />

                  <ExerciseHelperSection
                    equipments={
                      currentExercise?.exerciseLevel?.exerciseEquipmentUses?.map(
                        (equipment) => equipment.title
                      ) || []
                    }
                    onChangeLevel={() => {
                      navigate(`/program/change-level`, {
                        state: {
                          exercise: currentExercise,
                          activeDayId: activeDay,
                          programId: program.id,
                          redirectLink: "/assessment-timer",
                        },
                      });
                    }}
                    onShowEducationalVideo={() => {
                      handlePause();
                      handleShow();
                    }}
                    onShowInfo={() => {
                      setIsInfoModalOpen(true);
                    }}
                    isCompilation={
                      currentExercise?.compilation_video_id ? true : false
                    }
                  />

                  {/* Exercise Controls */}
                  <div className="timer_box">
                    <ul className="border_1">
                      {currentExercise.exerciseLevel.suggested_weight_lbs ? (
                        <li>
                          <div style={styles.container}>
                            <input
                              id={"dumbbells"}
                              type="number"
                              placeholder="--"
                              className={`form-control form-2 custom-input ${
                                hasChangedKg ? "input-changed" : ""
                              }`}
                              onChange={(e) => setDumbbellsValueFunc(e)}
                              step={2}
                              min={0}
                              max={1000}
                              onClick={clearDumbellsValue}
                              value={dumbbellsValue || ""}
                              style={styles.input}
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            <p style={styles.label}>POUNDS</p>
                            {errorDumbell && (
                              <span className="show-error">{errorDumbell}</span>
                            )}
                          </div>
                        </li>
                      ) : (
                        ""
                      )}
                      {currentExercise.exerciseLevel.metric === 10 ? (
                        <li>
                          <div style={styles.container}>
                            <input
                              id={"raps"}
                              type="number"
                              placeholder="--"
                              className={`form-control form-2 custom-input ${
                                hasChangedReps ? "input-changed" : ""
                              }`}
                              onChange={(e) => setRepsValueFunc(e)}
                              min={0}
                              onClick={clearRepsValue}
                              value={repsValue || ""}
                              max={1000}
                              style={styles.input}
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            <p style={styles.label}>REPS</p>
                            {error && (
                              <span className="show-error">{error}</span>
                            )}
                          </div>
                        </li>
                      ) : (
                        <>
                          <li>
                            <div style={styles.container}>
                              {isEditing ? (
                                <input
                                  type="text"
                                  className={`form-control form-2 custom-input ${
                                    hasChangedTime ? "input-changed" : ""
                                  }`}
                                  style={styles.input}
                                  value={inputValue}
                                  onChange={handleChange}
                                />
                              ) : (
                                <>
                                  <input
                                    type="text"
                                    className={`form-control form-2 custom-input ${
                                      hasChangedTime ? "input-changed" : ""
                                    }`}
                                    style={styles.input}
                                    onChange={(e) => setTimeValueFunc(e)}
                                    value={formatTime(seconds)}
                                    onClick={handleEdit}
                                    readOnly
                                  />
                                </>
                              )}
                              <p style={styles.label}>TIME</p>

                              {error && (
                                <span className="show-error">{error}</span>
                              )}
                            </div>
                          </li>
                        </>
                      )}

                      {isStart &&
                        (currentExercise.exerciseLevel.metric === 20 ? (
                          <>
                            {!isTimerActive ? (
                              seconds === 0 ? (
                                <div className="d-flex">
                                  <Button
                                    className="mr-20 timer-btn"
                                    style={{
                                      ...styles.buttonStart,
                                      ...(isHovered ? styles.buttonHover : {}),
                                    }}
                                    onClick={() => handleStart()}
                                    disabled={
                                      !isPaused || isCompleted || isEditing
                                    }
                                  >
                                    <TimerIcon /> <small>Start Timer</small>
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="theme_btn_yellow mr-20"
                                  style={{
                                    ...styles.button,
                                    ...(isHovered ? styles.buttonHover : {}),
                                  }}
                                  onClick={() => handleResume()}
                                  disabled={isCompleted}
                                >
                                  Resume
                                </Button>
                              )
                            ) : (
                              <Button
                                className="theme_btn_yellow mr-20"
                                style={{
                                  ...styles.button,
                                  ...(isHovered ? styles.buttonHover : {}),
                                }}
                                onClick={() => handlePause()}
                                disabled={isCompleted}
                              >
                                Pause
                              </Button>
                            )}
                            {seconds !== 0 && isTimeChanged && (
                              <>
                                <Button
                                  className="theme_btn1 mr-20 btn-finish"
                                  style={{
                                    ...styles.button,
                                    ...(isHovered ? styles.buttonHover : {}),
                                  }}
                                  onClick={() => handleFinishNew()}
                                  disabled={isCompleted}
                                >
                                  Finish
                                </Button>
                                <Button
                                  className="theme_btn1 mr-20 ml-5"
                                  style={{
                                    ...styles.buttonNext,
                                    ...(isHovered ? styles.buttonHover : {}),
                                  }}
                                  onClick={() => handleFinish()}
                                  disabled={isCompleted}
                                >
                                  Next
                                </Button>
                              </>
                            )}
                          </>
                        ) : (
                          <Button
                            className="mr-20"
                            style={{
                              ...styles.button,
                              ...(isHovered ? styles.buttonHover : {}),
                            }}
                            onClick={() => handleFinish()}
                          >
                            Done
                          </Button>
                        ))}
                    </ul>

                    {isStart && (
                      <Link
                        to="#"
                        className="mb-4 text-dark float-right"
                        onClick={() => {
                          setShowExerciseSkipModal(true);
                        }}
                      >
                        {"SKIP>>"}
                      </Link>
                    )}

                    {currentExercise.exerciseLevel
                      ? currentExercise.exerciseLevel?.exerciseEquipmentUses
                          ?.title
                      : ""}
                    <textarea
                      className="form-control text-left p-3 note-textbox"
                      rows="5"
                      maxLength="500"
                      name="note"
                      id="note"
                      placeholder="Type your notes here"
                      value={noteValue}
                      onChange={(e) => setNoteValueFunc(e)}
                    ></textarea>
                    {errorNote && (
                      <span className="show-error">{errorNote}</span>
                    )}
                  </div>

                  <ExerciseHistory
                    userProgramDayExercisesAttempt={exerciseAttempts}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <ExerciseEducationalVideoModal
            show={showEducationalModal}
            handleClose={handleClose}
            videos={
              currentExercise
                ? currentExercise.exerciseLevel
                  ? currentExercise.exerciseLevel.exerciseEducationVideo
                  : null
                : null
            }
          />
          <SkipExerciseModal
            show={showExerciseSkipModal}
            handleClose={handleCloseExerciseSkipModal}
            skipTestReasons={skipTestReason ? skipTestReason : null}
            exerciseId={currentExercise ? currentExercise.id : null}
            dayId={currentExercise ? currentExercise.user_program_day_id : null}
          />
          <StatusCheckoutModal
            show={showStatusOutModal}
            handleClose={handleStatusOutModal}
            dayId={currentExercise ? currentExercise.user_program_day_id : null}
          />

          {/* TODO: Move modals to separate components */}
          {/* Modal weight change feedback */}

          <Modal
            show={showWeight}
            onHide={handleCloseWeight}
            id="user-weight-modal"
            centered
            size="xl"
          >
            <Modal.Header>
              <h3 className="text-center m-2">Select Exercise Intensity</h3>
            </Modal.Header>

            <Modal.Body className="text-center">
              <div className="d-flex justify-content-center flex-wrap">
                {[...Array(9)].map((_, index) => {
                  const intensity = index + 1;
                  const colorCodes = [
                    "#B5E1BB",
                    "#87E196",
                    "#4DD364",
                    "#49B2DF",
                    "#5098D6",
                    "#236297",
                    "#FFA196",
                    "#DC5C51",
                    "#FE0012",
                    "#BF000B",
                  ];
                  return (
                    <div
                      key={intensity}
                      className="d-flex flex-column align-items-center mb-3"
                    >
                      <Button
                        className={`btn ${
                          selectedIntensity === intensity
                            ? "btn-primary active"
                            : "btn-success"
                        }`}
                        onClick={() =>
                          handleSelectIntensity(
                            intensity,
                            currentExercise?.exercise?.weight_scale == 0
                              ? precisionLift[index].weight_change
                              : heavyLift[index].weight_change
                          )
                        }
                        style={{
                          width: "70px",
                          height: "50px",
                          fontWeight: "500",
                          fontSize: "22px", // Increase font size
                          color: "#000",
                          backgroundColor: colorCodes[index],
                          borderStyle:
                            selectedIntensity === intensity
                              ? "solid"
                              : "hidden",
                          borderColor:
                            selectedIntensity === intensity
                              ? "#FFD700"
                              : "#000", // Gold border when active
                          borderWidth:
                            selectedIntensity === intensity ? "3px" : "1px", // Thicker border when active
                          boxShadow:
                            selectedIntensity === intensity
                              ? "0 0 10px rgba(255, 215, 0, 0.8)"
                              : "none", // Glow effect
                        }}
                      >
                        {intensity}
                      </Button>

                      <p
                        className="mt-2 text-center"
                        style={{
                          fontSize: "12px",
                          width: "90px",
                          wordWrap: "break-word",
                        }}
                      >
                        {currentExercise?.exercise?.weight_scale === 0
                          ? precisionLift[index].difficulty
                          : heavyLift[index].difficulty}
                      </p>
                    </div>
                  );
                })}
              </div>

              <div className="text-center mt-4">
                <Button className="theme_btn1 mr-20" onClick={handleSubmit}>
                  Submit
                </Button>
              </div>
            </Modal.Body>
          </Modal>

          <ExerciseInfoModal
            isOpen={isInfoModalOpen}
            onClose={handleCloseExercise}
            currentExercise={currentExercise}
            viewportWidth={viewportWidth}
          />

          <EndExerciseConfirmModal
            isOpen={isEndExerciseConfirmModalOpen}
            onClose={handleEndExerciseConfirmModalClose}
            onRepeatCircuit={handleRepeatCircuit}
            onCompleteExercise={handleCompleteExercise}
            setNumber={exerciseAttempts.length}
          />

          <EndExerciseModal
            isEndExercise={isEndExercise}
            handleEndExercise={handleEndExercise}
          />
        </section>
      </CommonPageData>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    exerciseUpdateRequest: state.programReducer.exerciseUpdateRequest || null,
    exerciseUpdateSuccess: state.programReducer.exerciseUpdateSuccess || null,
    exerciseUpdateFailure: state.programReducer.exerciseUpdateFailure || null,
    skipExerciseSuccess: state.testReducer.skipExerciseSuccess,
    skipTestReason: state.testReducer.skipTestReason,
    activeExercise: state.userActiveExerciseReducer.exercise,
  };
};

export default connect(mapStateToProps, {
  updateUserProgramDayExercise,
  getSkipReasons,
  flipExerciseOrientation,
  incrementCircuitCount,
})(ExerciseContainer);
